import { render, staticRenderFns } from "./HerosForm.vue?vue&type=template&id=ebdaf116&scoped=true"
import script from "./HerosForm.vue?vue&type=script&lang=js"
export * from "./HerosForm.vue?vue&type=script&lang=js"
import style0 from "./HerosForm.vue?vue&type=style&index=0&id=ebdaf116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdaf116",
  null
  
)

export default component.exports